import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { comparisonTableTimeLineObj } from 'assets/animation/portalAnimation';

const row = {
    includeIc: <img src={images.tableCheckIcon} alt="Icon" />,
    notIncludeIc: <img src={images.tableCrossIcon} alt="Icon" />,
};

const ClinicalPractices: React.FC = () => {
    const comparisonTableTimeLine = React.useRef(null);

    React.useEffect(() => {
        comparisonTableTimeLineObj(comparisonTableTimeLine);
    }, []);

    return (
        <section className="comparison-table" ref={comparisonTableTimeLine}>
            <Container maxWidth="lg">
                <Typography variant="h3" className="section-title">
                    Comparison of contemporary clinical practices
                </Typography>
                <div className="custom-table">
                    <TableContainer>
                        <Table aria-label="simple table" style={{ tableLayout: 'fixed', minWidth: '900px' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        className="sticky-cell"
                                        sx={{
                                            border: '0 !important',
                                            backgroundColor: '#FFFFFF !important',
                                        }}
                                    >
                                        &nbsp;
                                    </TableCell>
                                    <TableCell align="center" className="portal-head">
                                        Healthreach
                                    </TableCell>
                                    <TableCell align="center">Traditional Clinical Practice</TableCell>
                                    <TableCell align="center">
                                        Working from home <br />
                                        <span>(with off-the-shelf products)</span>
                                    </TableCell>
                                    <TableCell align="center">Other telehealth clinics</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row" className="sticky-cell">
                                        Technological advantage
                                    </TableCell>
                                    <TableCell className="portal-cell"></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        In-house software designed by Australian doctors and clinicians
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        No need to switch between programs
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>Usually multiple programs required</TableCell>
                                    <TableCell>Usually multiple programs required</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Secure data storage and backup
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>Depends if clinics have secure practices and policies</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>Depends if clinics have secure practices and policies</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Uniquely designed time-saving documentation features
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="sticky-cell"
                                        sx={{
                                            borderTop: '0 !important',
                                        }}
                                    >
                                        Flexibility and Freedom
                                    </TableCell>
                                    <TableCell className="portal-cell"></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Flexibility to work anytime, anywhere
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>
                                        {row.notIncludeIc}Usually requires at least half a day plus travel
                                    </TableCell>
                                    <TableCell>{row.includeIc}</TableCell>
                                    <TableCell>Depends</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Full administrative support
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>
                                        {row.notIncludeIc}
                                        Large amount of administrative burden
                                    </TableCell>
                                    <TableCell>{row.notIncludeIc}Only partial services are offered</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Financial reporting at your fingertips
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Low fees, no commitment
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        In total control of your time and appointments
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Freedom to decide on nature of your practice
                                    </TableCell>
                                    <TableCell className="portal-cell">
                                        {row.includeIc} bulk bill or gap, your choice
                                    </TableCell>
                                    <TableCell>Depends on practice</TableCell>
                                    <TableCell>{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell scope="row" className="title-cell">
                                        Your safety when dealing with difficult patients
                                    </TableCell>
                                    <TableCell className="portal-cell">{row.includeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.notIncludeIc}</TableCell>
                                    <TableCell>{row.includeIc}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Container>
        </section>
    );
};

export default React.memo(ClinicalPractices);
